import React from "react";
import { useSelector } from "react-redux";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import 'bootstrap-icons/font/bootstrap-icons.css';

import LogoutPage from './Logout';
import profile from "../../../images/profile/profile.jfif";
// import avatar from "../../../avatar/1.jpg";

const Header = ({ onNote, toggle, onProfile, onNotification, onClick }) => {
  const location = useLocation();
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
    ? filterName.filter((f) => f !== "ui")
    : filterName.includes("uc")
    ? filterName.filter((f) => f !== "uc")
    : filterName.includes("basic")
    ? filterName.filter((f) => f !== "basic")
    : filterName.includes("jquery")
    ? filterName.filter((f) => f !== "jquery")
    : filterName.includes("table")
    ? filterName.filter((f) => f !== "table")
    : filterName.includes("page")
    ? filterName.filter((f) => f !== "page")
    : filterName.includes("email")
    ? filterName.filter((f) => f !== "email")
    : filterName.includes("ecom")
    ? filterName.filter((f) => f !== "ecom")
    : filterName.includes("chart")
    ? filterName.filter((f) => f !== "chart")
    : filterName.includes("editor")
    ? filterName.filter((f) => f !== "editor")
    : filterName;

  const storeState = useSelector((state) => state);
  const profileImage = useSelector((state) => state.Login?.user?.photo);

  const navItems = [
    { path: "/diet-plan", label: "Alimentation", icon: "bi-egg-fried" },
    { path: "/wokoutPlan", label: "Exercices", icon: "bi-activity" },
    { path: "/history", label: "Historique", icon: "bi-calendar-check" },
  ];
  
  const {changeBackground, background} = useContext(ThemeContext);		
  function handelChangeMode(){
    if(background.value==="light"){
      changeBackground({ value: "dark", label: "Dark" });  
    }
    else {
      changeBackground({ value: "light", label: "Light" });  
    }
  }

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            {/* Header Left - Title */}
            <div className="header-left d-none d-md-flex">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize", fontSize: "18px", whiteSpace: "nowrap" }}
              >
                {finalName.join(" ").length === 0
                  ? "Dashboard"
                  : finalName.join(" ")}
              </div>
            </div>
            
            {/* Navigation Items - Center */}
            <Nav className="mx-auto" style={{ flexWrap: "nowrap" }}>
              {navItems.map(({ path, label, icon }) => (
                <Nav.Link
                  as={Link}
                  to={path}
                  key={path}
                  className={`mx-1 d-flex align-items-center ${
                    location.pathname === path ? 'text-primary fw-bold' : ''
                  }`}
                  style={{ 
                    fontFamily: "'Segoe UI', sans-serif", 
                    fontSize: "16px", 
                    whiteSpace: "nowrap",
                    padding: "0 10px"
                  }}
                >
                  <i className={`bi ${icon} me-1`}></i>
                  <span className="d-none d-sm-inline">{label}</span>
                </Nav.Link>
              ))}
            </Nav>
            
            {/* Header Right - Icons */}
            <ul className="navbar-nav header-right" style={{ flexWrap: "nowrap" }}>
              {/* Theme Toggle */}
              <li className="nav-item dropdown notification_dropdown">
                <Link to={"#"} className={`nav-link bell dz-theme-mode ${background.value==="dark" ? 'active': ''}`}
                  onClick={handelChangeMode}
                >
                  <i id="icon-light" className="fas fa-sun"></i>
                  <i id="icon-dark" className="fas fa-moon"></i>								
                </Link>
              </li>
              
              {/* Notifications */}
              <Dropdown as="li" className="nav-item notification_dropdown">
                <Dropdown.Toggle variant="" className="nav-link ai-icon i-false">
                  <svg width={22} height={22} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.75 15.8385V13.0463C22.7471 10.8855 21.9385 8.80353 20.4821 7.20735C19.0258 5.61116 17.0264 4.61555 14.875 4.41516V2.625C14.875 2.39294 14.7828 2.17038 14.6187 2.00628C14.4546 1.84219 14.2321 1.75 14 1.75C13.7679 1.75 13.5454 1.84219 13.3813 2.00628C13.2172 2.17038 13.125 2.39294 13.125 2.625V4.41534C10.9736 4.61572 8.97429 5.61131 7.51794 7.20746C6.06159 8.80361 5.25291 10.8855 5.25 13.0463V15.8383C4.26257 16.0412 3.37529 16.5784 2.73774 17.3593C2.10019 18.1401 1.75134 19.1169 1.75 20.125C1.75076 20.821 2.02757 21.4882 2.51969 21.9803C3.01181 22.4724 3.67904 22.7492 4.375 22.75H9.71346C9.91521 23.738 10.452 24.6259 11.2331 25.2636C12.0142 25.9013 12.9916 26.2497 14 26.2497C15.0084 26.2497 15.9858 25.9013 16.7669 25.2636C17.548 24.6259 18.0848 23.738 18.2865 22.75H23.625C24.321 22.7492 24.9882 22.4724 25.4803 21.9803C25.9724 21.4882 26.2492 20.821 26.25 20.125C26.2486 19.117 25.8998 18.1402 25.2622 17.3594C24.6247 16.5786 23.7374 16.0414 22.75 15.8385ZM7 13.0463C7.00232 11.2113 7.73226 9.45223 9.02974 8.15474C10.3272 6.85726 12.0863 6.12732 13.9212 6.125H14.0788C15.9137 6.12732 17.6728 6.85726 18.9703 8.15474C20.2677 9.45223 20.9977 11.2113 21 13.0463V15.75H7V13.0463ZM14 24.5C13.4589 24.4983 12.9316 24.3292 12.4905 24.0159C12.0493 23.7026 11.716 23.2604 11.5363 22.75H16.4637C16.284 23.2604 15.9507 23.7026 15.5095 24.0159C15.0684 24.3292 14.5411 24.4983 14 24.5ZM23.625 21H4.375C4.14298 20.9999 3.9205 20.9076 3.75644 20.7436C3.59237 20.5795 3.50014 20.357 3.5 20.125C3.50076 19.429 3.77757 18.7618 4.26969 18.2697C4.76181 17.7776 5.42904 17.5008 6.125 17.5H21.875C22.571 17.5008 23.2382 17.7776 23.7303 18.2697C24.2224 18.7618 24.4992 19.429 24.5 20.125C24.4999 20.357 24.4076 20.5795 24.2436 20.7436C24.0795 20.9076 23.857 20.9999 23.625 21Z" fill="#555555"/>
                  </svg>
                  <span className="badge light text-white bg-primary">5</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu-end">
                  {/* Dropdown content here */}
                </Dropdown.Menu>
              </Dropdown>
              
              {/* Messages */}
              <Dropdown as="li" className="nav-item notification_dropdown">
                <Dropdown.Toggle variant="" className="nav-link bell bell-link i-false" onClick={() => onNote()}>
                  <svg width={22} height={22} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.4605 3.84888H5.31688C4.64748 3.84961 4.00571 4.11586 3.53237 4.58919C3.05903 5.06253 2.79279 5.7043 2.79205 6.3737V18.1562C2.79279 18.8256 3.05903 19.4674 3.53237 19.9407C4.00571 20.4141 4.64748 20.6803 5.31688 20.6811C5.54005 20.6812 5.75404 20.7699 5.91184 20.9277C6.06964 21.0855 6.15836 21.2995 6.15849 21.5227V23.3168C6.15849 23.6215 6.24118 23.9204 6.39774 24.1818C6.5543 24.4431 6.77886 24.6571 7.04747 24.8009C7.31608 24.9446 7.61867 25.0128 7.92298 24.9981C8.22729 24.9834 8.52189 24.8863 8.77539 24.7173L14.6173 20.8224C14.7554 20.7299 14.918 20.6807 15.0842 20.6811H19.187C19.7383 20.68 20.2743 20.4994 20.7137 20.1664C21.1531 19.8335 21.4721 19.3664 21.6222 18.8359L24.8966 7.05011C24.9999 6.67481 25.0152 6.28074 24.9414 5.89856C24.8675 5.51637 24.7064 5.15639 24.4707 4.84663C24.235 4.53687 23.931 4.28568 23.5823 4.11263C23.2336 3.93957 22.8497 3.84931 22.4605 3.84888ZM23.2733 6.60304L20.0006 18.3847C19.95 18.5614 19.8432 18.7168 19.6964 18.8275C19.5496 18.9381 19.3708 18.9979 19.187 18.9978H15.0842C14.5856 18.9972 14.0981 19.1448 13.6837 19.4219L7.84171 23.3168V21.5227C7.84097 20.8533 7.57473 20.2115 7.10139 19.7382C6.62805 19.2648 5.98628 18.9986 5.31688 18.9978C5.09371 18.9977 4.87972 18.909 4.72192 18.7512C4.56412 18.5934 4.4754 18.3794 4.47527 18.1562V6.3737C4.4754 6.15054 4.56412 5.93655 4.72192 5.77874C4.87972 5.62094 5.09371 5.53223 5.31688 5.5321H22.4605C22.5905 5.53243 22.7188 5.56277 22.8353 5.62076C22.9517 5.67875 23.0532 5.76283 23.1318 5.86646C23.2105 5.97008 23.2642 6.09045 23.2887 6.21821C23.3132 6.34597 23.308 6.47766 23.2733 6.60304Z" fill="#555555"/>
                  </svg>
                  <span className="badge light text-white bg-primary">3</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu-end">
                  {/* Dropdown content here */}
                </Dropdown.Menu>
              </Dropdown>
              
              {/* Profile */}
              <Dropdown as="li" className="nav-item header-profile">
                <Dropdown.Toggle as="a" to="#" variant="" className="nav-link i-false c-pointer">								
                  <img src={profileImage || profile} width="20" alt=""/>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu-end">
                  <Link to="/app-profile" className="dropdown-item ai-icon">
                    <svg id="icon-user1" xmlns="http://www.w3.org/2000/svg" className="text-primary" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">Profile</span>
                  </Link>
                  <Link to="/email-inbox" className="dropdown-item ai-icon">
                    <svg id="icon-inbox" xmlns="http://www.w3.org/2000/svg" className="text-success" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <span className="ms-2">Inbox</span>
                  </Link>
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;